import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-WorkPlacements-components-SelectEmployer', [
  'searchInput',
  'addEmployerButton',
  'employerOption',
  'selectedEmployer',
  'retryEmployersButton',
]);
